var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"list pa-0 ",attrs:{"cols":"12"}},[_c('iframe',{ref:"frame",staticClass:"a4",attrs:{"srcdoc":_vm.view}})])}
var staticRenderFns = []

export { render, staticRenderFns }